import React from 'react';
import { IconDouble, IconNoSmoking, IconPrivateBathroom, IconSofa, IconTwinBed, IconWindow } from 'assets/icons';

export const ICONS = {
  ['sofa']: { icon: (p) => <IconSofa {...p} />, label: 'Диван' },
  ['window']: { icon: (p) => <IconWindow {...p} />, label: 'Окно' },
  ['non-smoking']: { icon: (p) => <IconNoSmoking {...p} />, label: 'Не курить' },
  ['double']: { icon: (p) => <IconDouble {...p} />, label: 'Двуспальная кровать' },
  ['has_bathroom']: { icon: (p) => <IconPrivateBathroom {...p} />, label: 'Ванная комната' },
  ['private-bathroom']: { icon: (p) => <IconPrivateBathroom {...p} />, label: 'Ванная комната' },
  ['shared-bathroom']: { icon: (p) => <IconPrivateBathroom {...p} />, label: 'Общая ванная' },
  ['twin']: { icon: (p) => <IconTwinBed {...p} style={{ width: 32 }} />, label: 'Отдельные кровати' },
};
